<template>
    <div class="lb-project-box">
        <span
            v-if="content.pendingChanges"
            class="badge has-background-pink-red"
            >{{ content.pendingChanges }}
        </span>
        <div
            :style="`${background(content.background)}`"
            class="lb-project-background-card"
        />
        <div class="columns is-mobile is-marginless pt-1">
            <div class="column is-11 py-0 has-text-left pt-1">
                <p class="is-size-6 lb-card-title is-block has-text-black">
                    {{ content.title }}
                </p>
                <p class="is-size-7 lb-card-title is-block is-uppercase">
                    {{ contentType }}
                </p>
            </div>
            <div v-if="amOwner" class="column is-1" @click.stop.prevent="">
                <div class="dropdown is-right is-hoverable is-pulled-right">
                    <span
                        class="
                            icon
                            is-small
                            dropdown-trigger
                            has-text-grey
                            mt-1
                        "
                    >
                        <i
                            class="mdi mdi-36px mdi-dots-vertical"
                            aria-hidden="true"
                        />
                    </span>
                    <div class="dropdown-menu" role="menu">
                        <div class="dropdown-content">
                            <div
                                class="dropdown-item"
                                @click.stop.prevent="$emit('delete')"
                            >
                                <a v-t="'dropdown_option_delete_project'" />
                            </div>
                            <div
                                v-if="content.folder"
                                class="dropdown-item"
                                @click.stop.prevent="$emit('removeFromFolder')"
                            >
                                <a
                                    v-t="
                                        'Project.dropdown_option_remove_from_folder'
                                    "
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="level">
      <p class="has-text-grey">{{ content.owner.name }}</p>
    </div>-->
    </div>
</template>

<script>
import { projectBackground } from '@/lib/helpers';
import _ from 'underscore';
export default {
    props: {
        content: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            showToolbar: false,
        };
    },
    computed: {
        background() {
            return (bg) => {
                return projectBackground(
                    !_.isEmpty(this.content.image)
                        ? this.content.image
                        : !_.isEmpty(this.content.backgroundImage)
                        ? this.content.backgroundImage
                        : bg
                );
            };
        },
        amOwner() {
            if (typeof this.content.owner === 'object') {
                return (
                    this.content.owner.owner === this.$store.getters.user.owner
                );
            } else {
                return this.content.owner === this.$store.getters.user.owner;
            }
        },
        contentType() {
            if (
                this.content.type == 'collection' &&
                this.content.mode == 'map'
            ) {
                return this.$t(`Creation.contentmap.title`);
            } else if (
                this.content.type == 'trivial' &&
                this.content.mode == 'map'
            ) {
                return this.$t(`Creation.trivialgeo.title`);
            } else return this.$t(`Creation.${this.content.type}.title`);
        },
    },
    methods: {},
};
</script>

<style scoped>
.level {
    padding: 0 0.5em;
}
.edit-button {
    text-shadow: 0px 2px 4px #000;
}
.lb-card-title {
    max-width: 100%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.lb-project-background {
    transition: 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.lb-project-background {
    transform: scale(1, 1.035);
}

.lb-project-background {
    width: 100%;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
}
.toolbar {
    position: absolute;
    top: -25px;
    right: 10px;
}
.badge {
    z-index: 2;
    height: 30px;
    min-width: 30px;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    right: 32px;
    line-height: 24px;
    box-shadow: none;
}
.dropdown.is-right.is-hoverable {
    vertical-align: middle;
}
</style>
